import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PriceListRepository } from "./price-list.repository";

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [],
  providers: [PriceListRepository],
})
export class PriceListDomainModule {}
